import React, {
  lazy,
  Suspense,
  useEffect,
  useMemo,
  useRef,
  useState,
  MouseEvent,
} from "react";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import { CopyToClipboard } from "react-copy-to-clipboard";
import { DotLottieReact } from "@lottiefiles/dotlottie-react";
import FileDownloadIcon from "@mui/icons-material/FileDownload";
import UploadFileIcon from "@mui/icons-material/UploadFile";
import BrowserUpdatedIcon from "@mui/icons-material/BrowserUpdated";
import VisibilityIcon from "@mui/icons-material/Visibility";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
// import { Broker } from "./interface";
import Form from "react-bootstrap/Form";
// import "../../Components/SharedComponents/InputBox.scss";
import {
  MaterialReactTable,
  // createRow,
  type MRT_ColumnDef,
  MRT_ColumnFiltersState,
  MRT_DensityState,
  type MRT_Row,
  MRT_SortingState,
  type MRT_TableOptions,
  MRT_ToggleFiltersButton,
  MRT_ToggleFullScreenButton,
  MRT_VisibilityState,
  useMaterialReactTable,
} from "material-react-table";
import {
  Box,
  Button,
  IconButton,
  Menu,
  MenuItem,
  TextField,
  Tooltip,
  InputAdornment,
} from "@mui/material";
import {
  QueryClient,
  QueryClientProvider,
  useMutation,
  useQuery,
  useQueryClient,
} from "@tanstack/react-query";
import { fakeData, usStates } from "./makeData";
import { citiesList, usStateList } from "./makeData";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import Accordion from "react-bootstrap/Accordion";
import Table from "react-bootstrap/Table";
import { Col, Container, Row } from "reactstrap";
import axiosInstance from "../../Utils/axiosInstance";
import { backendbaseUrl } from "../../Utils/baseUrl";
import { toast } from "react-toastify";
import { StyledTableFirstSecond } from "../Book/TableBook";
import { showDeleteConfirmModal } from "../../Components/ConfirmModal";
import FormControl from "@mui/material/FormControl";
import Select, { SelectChangeEvent } from "@mui/material/Select";
import InputLabel from "@mui/material/InputLabel";
import {
  CompactSelect,
  CompactTextField,
} from "../../Components/SharedComponents/SharedComponents";
import { fetchUserDetails } from "../../api/backOfficeService";
import { TableColumnVisibilityMenu } from "../../Components/SharedComponents/TableColumnVisibilityMenu";
import { CommonToolbarInternalActions } from "../../Components/SharedComponents/CommonTableToolbarActions";
import { MRT_COLUMN_FILTERS_API_SETTINGS, MRT_COLUMN_VISIBILITY_API_SETTINGS, MRT_DENSITY_API_SETTINGS, MRT_GLOBAL_FILTERS_API_SETTINGS, MRT_SHOW_COLUMN_FILTERS_API_SETTINGS, MRT_SHOW_GLOBAL_FILTERS_API_SETTINGS, MRT_SORTING_API_SETTINGS } from "../../Constants/TableFilter.constants";

// Assuming these are defined in your makeData file
interface User {
  id: string;
  company_name: string;
  api_company_name: string;
  company_username: string;
  password: string;
  exchange_type: string;
  clearing_account?: { id: string; name: string };
  clearer?: { id: string; name: string };
  book?: { id: string; name: string };
  strategy?: { id: string; name: string };
}
type OptionType = { id: string; name: string };
// Add these interfaces at the top of your file
// Form data interface
// Form data interface
interface FormData {
  company_name: string;
  api_company_name: string;
  company_username: string;
  password: string;
  exchange_type: string;
  clearing_account: string; // Stores ID of the clearing account
  clearer: string; // Stores ID of the clearer
  book: string; // Stores ID of the book
  strategy: string; // Stores ID of the strategy
}
// Ultra compact select component

// Ultra compact text field component

const Example = () => {
  const [validationErrors, setValidationErrors] = useState<
    Record<string, string | undefined>
  >({});
  const isFirstRender = useRef(true);
  const [filterModes, setFilterModes] = useState<
    { mode: string; id: string; value: unknown }[]
  >([]);

  const [columnFilters, setColumnFilters] = useState<MRT_ColumnFiltersState>(
    []
  );
  const [columnVisibility, setColumnVisibility] = useState<MRT_VisibilityState>(
    {}
  );
  const [density, setDensity] = useState<MRT_DensityState>("comfortable");
  const [globalFilter, setGlobalFilter] = useState<string | undefined>(
    undefined
  );
  const [showGlobalFilter, setShowGlobalFilter] = useState(true);
  const [showColumnFilters, setShowColumnFilters] = useState(true);
  const [sorting, setSorting] = useState<MRT_SortingState>([]);
  const [brokerName, setBrokerName] = useState<string>("");
  const [inputBackgroundColour, setInputBackgroundColour] = useState("");
  const [pagination, setPagination] = useState({
    pageIndex: 0,
    pageSize: 100, //set different default page size by initializing the state here
  });

  const addButtonRef = useRef<HTMLButtonElement | null>(null);
  const [showRowResizing, setShowRowResizing] = useState<boolean>(true);
  const [totalCount, setTotalCount] = useState(0);

  const [exchangeTypes, setExchangeTypes] = useState<any[]>([
    { id: "ICE", name: "ICE" },
    { id: "TT", name: "TT" },
    // ... other exchange types ...
  ]);

  const [companyName, setCompanyName] = useState<any>("");
  const [companyUsername, setCompanyUsername] = useState<any>("");
  const [password, setPassword] = useState<any>("");

  const [clearingAccounts, setClearingAccounts] = useState<any[]>([]);
  const [clearers, setClearers] = useState<any[]>([]);
  const [books, setBooks] = useState<any[]>([]);
  const [strategies, setStrategies] = useState<any[]>([]);

  const [selectedExchangeType, setSelectedExchangeType] = useState<string>("");
  const [selectedClearingAccount, setSelectedClearingAccount] =
    useState<string>("");
  const [selectedClearer, setSelectedClearer] = useState<string>("");
  const [selectedBook, setSelectedBook] = useState<string>("");
  const [selectedStrategy, setSelectedStrategy] = useState<string>("");
  const [openFileUpload, setOpenFileUpload] = useState<boolean>(false);
  const [showPassword, setShowPassword] = useState<boolean>(false);
  const [loading, setLoading] = useState(false);

  // Toggle password visibility
  const handleTogglePassword = () => {
    setShowPassword((prev) => !prev);
  };
  // Single useState for form data
  // Unified form data state
  const [formData, setFormData] = useState<FormData>({
    company_name: "",
    api_company_name: "",
    company_username: "",
    password: "",
    exchange_type: "",
    clearing_account: "",
    clearer: "",
    book: "",
    strategy: "",
  });
  const [formErrors, setFormErrors] = useState<Partial<FormData>>({});
  const [touched, setTouched] = useState<
    Partial<Record<keyof FormData, boolean>>
  >({});

  const handleFileUploadOpen = () => setOpenFileUpload(true);
  const handleFileUploadClose = () => setOpenFileUpload(false);

  const handleFileUploadSubmit = async (file: File, fileName: string) => {
    const formData = new FormData();
    formData.append("file", file);
    formData.append("fileName", fileName);

    try {
      const response = await axiosInstance.post("", formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });
      return {
        success: true,
        message: response.data.message || "File uploaded successfully!",
      };
    } catch (error: any) {
      return {
        success: false,
        message: error.response?.data?.message || "Failed to upload file",
      };
    }
  };

  useEffect(() => {
    const getUserDetails = async () => {
      try {
        setLoading(true);
        const user = await fetchUserDetails();
        setFormData((prev) => ({
          ...prev,
          company_name: user.organization,
        }));
      } catch (error) {
        console.error("Error fetching user details:", error);
      } finally {
        setLoading(false);
      }
    };

    getUserDetails();
  }, []);
  // Validate individual field
  const validateField = (field: keyof FormData, value: string) => {
    let error = "";
    if (!value.trim()) {
      error = `${field
        .replace(/_/g, " ")
        .replace(/\b\w/g, (char) => char.toUpperCase())} is required`;
    }
    setFormErrors((prev) => ({ ...prev, [field]: error }));
    return error;
  };

  // Handle blur event
  const handleBlur = (field: keyof FormData, value: string) => {
    validateField(field, value);
  };

  // Validate entire form
  const validateFormData = () => {
    const newErrors: Partial<FormData> = {};
    Object.keys(formData).forEach((key) => {
      const field = key as keyof FormData;
      if (!formData[field].trim()) {
        newErrors[field] = `${field
          .replace(/_/g, " ")
          .replace(/\b\w/g, (char) => char.toUpperCase())} is required`;
      }
    });
    console.log("Form validation errors:", newErrors); // Debug
    setFormErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  // Update form data
  const updateFormData = (field: keyof FormData, value: string) => {
    console.log(`Updating ${field}: value="${value}"`); // Debug
    setFormData((prev) => ({ ...prev, [field]: value }));
    setTouched((prev) => ({ ...prev, [field]: true }));
    // Clear error if the field is valid
    if (value.trim()) {
      setFormErrors((prev) => ({ ...prev, [field]: undefined }));
    } else {
      validateField(field, value);
    }
  };

  // Handle focus to mark field as touched
  const handleFocus = (field: keyof FormData) => {
    setTouched((prev) => ({ ...prev, [field]: true }));
  };

  // Handle form input changes
  const handleInputChange = (
    e: React.ChangeEvent<HTMLInputElement> | SelectChangeEvent<string>,
    field: keyof FormData
  ) => {
    const value = "target" in e ? e.target.value : e;
    updateFormData(field, value);
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const clearerResponse = await axiosInstance.get(
          `${backendbaseUrl}/paper-app/api-settings-clearer/`
        );
        setClearers(clearerResponse.data);

        const bookResponse = await axiosInstance.get(
          `${backendbaseUrl}/paper-app/api-settings-book/`
        );
        setBooks(bookResponse.data);

        const strategyResponse = await axiosInstance.get(
          `${backendbaseUrl}/paper-app/api-settings-strategy/`
        );
        setStrategies(strategyResponse.data);

        const clearerAccount = await axiosInstance.get(
          `${backendbaseUrl}/paper-app/api-settings-clearing-account/`
        );
        setClearingAccounts(clearerAccount.data);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchData();
  }, []);

  // Validate individual field

  // Validation function for form data

  // Update form data

  useEffect(() => {
    //do something when the pagination state changes
  }, [pagination]);

  useEffect(() => {
    const columnFilters = sessionStorage.getItem(MRT_COLUMN_FILTERS_API_SETTINGS);
    const columnVisibility = sessionStorage.getItem(
      MRT_COLUMN_VISIBILITY_API_SETTINGS
    );
    const density = sessionStorage.getItem(MRT_DENSITY_API_SETTINGS);
    const globalFilter = sessionStorage.getItem(MRT_GLOBAL_FILTERS_API_SETTINGS);
    const showGlobalFilter = sessionStorage.getItem(
      MRT_SHOW_GLOBAL_FILTERS_API_SETTINGS
    );
    const showColumnFilters = sessionStorage.getItem(
      MRT_SHOW_COLUMN_FILTERS_API_SETTINGS
    );
    const sorting = sessionStorage.getItem(MRT_SORTING_API_SETTINGS);

    if (columnFilters) {
      setColumnFilters(JSON.parse(columnFilters));
    }
    if (columnVisibility) {
      setColumnVisibility(JSON.parse(columnVisibility));
    }
    if (density) {
      setDensity(JSON.parse(density));
    }
    if (globalFilter) {
      setGlobalFilter(JSON.parse(globalFilter) || undefined);
    }
    if (showGlobalFilter) {
      setShowGlobalFilter(JSON.parse(showGlobalFilter));
    }
    if (showColumnFilters) {
      setShowColumnFilters(JSON.parse(showColumnFilters));
    }
    if (sorting) {
      setSorting(JSON.parse(sorting));
    }
    isFirstRender.current = false;
  }, []);

  //save states to local storage
  useEffect(() => {
    if (isFirstRender.current) return;
    sessionStorage.setItem(
      MRT_COLUMN_FILTERS_API_SETTINGS,
      JSON.stringify(columnFilters)
    );
  }, [columnFilters]);
  //save states to local storage
  useEffect(() => {
    if (isFirstRender.current) return;
    sessionStorage.setItem(
      MRT_COLUMN_FILTERS_API_SETTINGS,
      JSON.stringify(columnFilters)
    );

    console.log("columnFilters", "columnFilters---------------", columnFilters);
  }, [columnFilters]);

  useEffect(() => {
    if (isFirstRender.current) return;
    sessionStorage.setItem(
      MRT_COLUMN_VISIBILITY_API_SETTINGS,
      JSON.stringify(columnVisibility)
    );
  }, [columnVisibility]);

  useEffect(() => {
    if (isFirstRender.current) return;
    sessionStorage.setItem(MRT_DENSITY_API_SETTINGS, JSON.stringify(density));
  }, [density]);

  useEffect(() => {
    if (isFirstRender.current) return;
    sessionStorage.setItem(
      MRT_GLOBAL_FILTERS_API_SETTINGS,
      JSON.stringify(globalFilter ?? "")
    );
  }, [globalFilter]);

  useEffect(() => {
    if (isFirstRender.current) return;
    sessionStorage.setItem(
      MRT_SHOW_GLOBAL_FILTERS_API_SETTINGS,
      JSON.stringify(showGlobalFilter)
    );
  }, [showGlobalFilter]);

  useEffect(() => {
    if (isFirstRender.current) return;
    sessionStorage.setItem(
      MRT_SHOW_COLUMN_FILTERS_API_SETTINGS,
      JSON.stringify(showColumnFilters)
    );
  }, [showColumnFilters]);

  useEffect(() => {
    if (isFirstRender.current) return;
    sessionStorage.setItem(MRT_SORTING_API_SETTINGS, JSON.stringify(sorting));
  }, [sorting]);

  const commonCellProps = ({ row, table }: { row: any; table: any }) => ({
  onDoubleClick: () => {
    table.setEditingRow(row);
  },
  sx: {
    height: "10px",
    cursor: "pointer",
    "&:hover": {
      backgroundColor: "rgba(44, 4, 4, 0.05)",
    },
    ...(table.getState().editingRow?.id === row.id && {
      backgroundColor: "rgba(0, 128, 0, 0.1)",
      transition: "background-color 0.3s ease",
    }),
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
  },
});

  const columns = useMemo<MRT_ColumnDef<any>[]>(
    () => [
      {
        accessorKey: "company_name",
        header: "Company Name",
        enableEditing: true,
        muiTableBodyCellProps: commonCellProps,
        muiEditTextFieldProps: {
          name: "company_name",
          required: true,
          error: !!validationErrors?.company_name,
          helperText: validationErrors?.company_name,
          onFocus: () =>
            setValidationErrors((prev) => ({
              ...prev,
              company_name: undefined,
            })),
        },
      },
      {
        accessorKey: "api_company_name",
        header: "API Company Name",
        enableEditing: true,
        muiTableBodyCellProps: commonCellProps,
        muiEditTextFieldProps: {
          name: "api_company_name",
          required: true,
          error: !!validationErrors?.company_name,
          helperText: validationErrors?.company_name,
          onFocus: () =>
            setValidationErrors((prev) => ({
              ...prev,
              company_name: undefined,
            })),
        },
      },
      {
        accessorKey: "company_username",
        header: "Company Username",
        enableEditing: true,
        muiTableBodyCellProps: commonCellProps,
        muiEditTextFieldProps: {
          name: "company_username",
          required: true,
          error: !!validationErrors?.company_username,
          helperText: validationErrors?.company_username,
          onFocus: () =>
            setValidationErrors((prev) => ({
              ...prev,
              company_username: undefined,
            })),
        },
      },
      {
        accessorKey: "password",
        header: "Password",
        enableEditing: true,
        muiTableBodyCellProps: commonCellProps,
        muiEditTextFieldProps: {
          name: "password",
          required: true,
          error: !!validationErrors?.password,
          helperText: validationErrors?.password,
          onFocus: () =>
            setValidationErrors((prev) => ({
              ...prev,
              password: undefined,
            })),
        },
      },
      {
        accessorKey: "exchange_type",
        header: "Exchange Type",
        enableEditing: true,
        muiTableBodyCellProps: commonCellProps,
        muiEditTextFieldProps: {
          name: "exchange_type",
          required: true,
          error: !!validationErrors?.exchange_type,
          helperText: validationErrors?.exchange_type,
          onFocus: () =>
            setValidationErrors((prev) => ({
              ...prev,
              exchange_type: undefined,
            })),
          select: true,
          children: exchangeTypes.map((type) => (
            <MenuItem key={type.id} value={type.id}>
              {type.name}
            </MenuItem>
          )),
        },
      },
      {
        header: "Clearing Account",
        id: "clearing_account",
        accessorKey: "clearing_account.name",
        enableEditing: true,
        muiTableBodyCellProps: commonCellProps,
        muiEditTextFieldProps: ({ row }) => ({
          name: "clearing_account_id",
          required: true,
          select: true,
          value:
            row._valuesCache?.clearing_account_id ??
            row.original.clearing_account?.id ??
            "",
          onChange: (e) => {
            row._valuesCache = {
              ...row._valuesCache,
              clearing_account_id: e.target.value,
            };
          },
          children: clearingAccounts.map((acc) => (
            <MenuItem key={acc.id} value={acc.id}>
              {acc.name}
            </MenuItem>
          )),
        }),
      }
      ,
      {
        header: "Clearer",
        id: "clearer",
        accessorKey: "clearer.name",
        enableEditing: true,
        muiTableBodyCellProps: commonCellProps,
        muiEditTextFieldProps: ({ row }) => ({
          name: "clearer_id",
          required: true,
          select: true,
          value: row._valuesCache?.clearer_id ?? row.original.clearer?.id ?? "",
          onChange: (e) => {
            row._valuesCache = {
              ...row._valuesCache,
              clearer_id: e.target.value,
            };
          },
          children: clearers.map((c) => (
            <MenuItem key={c.id} value={c.id}>
              {c.name}
            </MenuItem>
          )),
        }),
      }
      ,
      {
        header: "Book",
        id: "book",
        accessorKey: "book.name",
        enableEditing: true,
        muiTableBodyCellProps: commonCellProps,
        muiEditTextFieldProps: ({ row }) => ({
          name: "book_id",
          required: true,
          select: true,
          value: row._valuesCache?.book_id ?? row.original.book?.id ?? "",
          onChange: (e) => {
            row._valuesCache = {
              ...row._valuesCache,
              book_id: e.target.value,
            };
          },
          children: books.map((b) => (
            <MenuItem key={b.id} value={b.id}>
              {b.name}
            </MenuItem>
          )),
        }),
      }
      ,
      {
        header: "Strategy",
        id: "strategy",
        accessorKey: "strategy.name",
        enableEditing: true,
        muiTableBodyCellProps: commonCellProps,
        muiEditTextFieldProps: ({ row }) => ({
          name: "strategy_id",
          required: true,
          select: true,
          value:
            row._valuesCache?.strategy_id ?? row.original.strategy?.id ?? "",
          onChange: (e) => {
            row._valuesCache = {
              ...row._valuesCache,
              strategy_id: e.target.value,
            };
          },
          children: strategies.map((s) => (
            <MenuItem key={s.id} value={s.id}>
              {s.name}
            </MenuItem>
          )),
        }),
      }
    ],
    [
      validationErrors,
      clearingAccounts,
      clearers,
      books,
      strategies,
      exchangeTypes,
    ]
  );

  //call CREATE hook
  const { mutateAsync: createUser, isPending: isCreatingUser } =
    useCreateUser();
  //call READ hook
  const {
    data,
    isError: isLoadingUsersError,
    isFetching: isFetchingUsers,
    isLoading: isLoadingUsers,
  } = useGetData(pagination, setTotalCount, sorting);
  //call UPDATE hook

  const { mutateAsync: updateUser, isPending: isUpdatingUser } =
    useUpdateUser();
  //call DELETE hook
  const { mutateAsync: deleteUser, isPending: isDeletingUser } =
    useDeleteUser();
  const [errors, setErrors] = useState({
    companyName: "",
    companyUsername: "",
    password: "",
  });

  // Validation function
  const validateForm = () => {
    const newErrors = {
      companyName: "",
      companyUsername: "",
      password: "",
    };

    if (!companyName.trim()) {
      newErrors.companyName = "Company Name is required";
    }
    if (!companyUsername.trim()) {
      newErrors.companyUsername = "Company Username is required";
    }
    if (!password.trim()) {
      newErrors.password = "Password is required";
    }

    setErrors(newErrors);

    // Return true if there are no errors
    return (
      !newErrors.companyName &&
      !newErrors.companyUsername &&
      !newErrors.password
    );
  };
  // CREATE FUNCTION TO ADD NEW A BROKER
  // CREATE FUNCTION TO ADD NEW A BROKER
  // CREATE FUNCTION TO ADD NEW BROKER
  // CREATE FUNCTION TO ADD NEW BROKER
  // CREATE FUNCTION TO ADD NEW BROKER
  const createBroker = async (broker: FormData) => {
    try {
      const apiPayload = {
        company_name: broker.company_name.trim(),
        api_company_name: broker.api_company_name.trim(),
        company_username: broker.company_username.trim(),
        password: broker.password.trim(),
        exchange_type: broker.exchange_type,
        clearing_account_id: broker.clearing_account,
        clearer_id: broker.clearer,
        book_id: broker.book,
        strategy_id: broker.strategy,
      };

      await axiosInstance.post(
        `${backendbaseUrl}/paper-app/api-settings/`,
        apiPayload
      );

      queryClient.invalidateQueries({ queryKey: ["users"] });
      toast.success("API Settings added successfully!");
    } catch (error) {
      console.error("Error adding API Settings:", error);
      toast.error("Failed to add API Settings. Please try again.");
    }
  };
  // create by submitting the form
  // create by submitting the form
  // Form submission handler
  // Form submission handler
  // Form submission handler
  const formCreate = async (e: React.MouseEvent<HTMLButtonElement>) => {
    console.log("click");

    e.preventDefault();
    setTouched({
      company_name: true,
      api_company_name: true,
      company_username: true,
      password: true,
      exchange_type: true,
      clearing_account: true,
      clearer: true,
      book: true,
      strategy: true,
    });

    if (!validateFormData()) {
      return;
    }

    await createBroker(formData);

    // Reset the form
    setFormData({
      company_name: "",
      api_company_name: "",
      company_username: "",
      password: "",
      exchange_type: "",
      clearing_account: "",
      clearer: "",
      book: "",
      strategy: "",
    });
    setFormErrors({});
    setTouched({});
  };

  //CREATE action
  // Update handleCreateUser to use snake_case
  const handleCreateUser: MRT_TableOptions<User>["onCreatingRowSave"] = async ({
    values,
    table,
  }) => {
    const newValidationErrors: Record<string, string> = {
      company_name: !validateRequired(values.company_name)
        ? "Company Name is required"
        : "",
      api_company_name: !validateRequired(values.api_company_name)
        ? "API Company Name is required"
        : "",
      company_username: !validateRequired(values.company_username)
        ? "Company Username is required"
        : "",
      password: !validateRequired(values.password)
        ? "Password is required"
        : "",
      exchange_type: !validateRequired(values.exchange_type)
        ? "Exchange Type is required"
        : "",
      clearing_account: !values.clearing_account
        ? "Clearing Account is required"
        : "",
      clearer: !values.clearer ? "Clearer is required" : "",
      book: !values.book ? "Book is required" : "",
      strategy: !values.strategy ? "Strategy is required" : "",
    };

    if (Object.values(newValidationErrors).some((error) => error)) {
      setValidationErrors(newValidationErrors);
      return;
    }

    setValidationErrors({});

    // Construct broker object to match FormData interface
    const broker: FormData = {
      company_name: values.company_name.trim(),
      api_company_name: values.api_company_name.trim(),
      company_username: values.company_username.trim(),
      password: values.password.trim(),
      exchange_type: values.exchange_type,
      clearing_account: values.clearing_account,
      clearer: values.clearer,
      book: values.book,
      strategy: values.strategy,
    };

    await createBroker(broker);
    table.setCreatingRow(null);
  };

  //UPDATE action
  //UPDATE action
  const handleeditsave: MRT_TableOptions<User>["onEditingRowSave"] = async ({
    values,
    table,
    row,
  }) => {
    // Create the payload the API expects
    const apiPayload = {
      ...values,
      id: row.original.id,
      clearing_account: row.original.clearing_account, // Use directly if it's a string
      clearer: row.original.clearer, // Use directly if it's a string
      book: row.original.book, // Use directly if it's a string
      strategy: row.original.strategy, // Use directly if it's a string
    };

    console.log("values", values);

    // Validate user data
    const newValidationErrors = validateUser(apiPayload);
    if (Object.values(newValidationErrors).some((error) => error)) {
      setValidationErrors(newValidationErrors);
      return;
    }

    setValidationErrors({});

    try {
      await updateUser(apiPayload);
      table.setEditingRow(null);
      toast.success("API Settings updated successfully!");
    } catch (error) {
      console.error("User Update Error:", error);
      toast.error("Failed to update API Settings. Please try again.");
    }
  };

  //DELETE action
  const openDeleteConfirmModal = (row: MRT_Row<User>) => {
    showDeleteConfirmModal({
      title: "Are you sure you want to delete this API Settings?",
      content: "Deleting...",
      onOk: () => {
        deleteUser(row.original.id)
          .then(() => {
            toast.success("API Settings deleted successfully!");
          })
          .catch((error) => {
            toast.error("Failed to delete API Settings. Please try again.");
          });
      },
    });
  };

  // Handle copy row (updated to use snake_case)
  const handleCopyRow = (row: any) => {
    if (!row) return;
    const rowData = row.original;

    // Copy the row data to clipboard as JSON
    const textToCopy = JSON.stringify(rowData, null, 2);
    navigator.clipboard.writeText(textToCopy);

    // Update form fields with the copied row data
    setFormData({
      company_name: rowData.company_name || "",
      api_company_name: rowData.api_company_name || "",
      company_username: rowData.company_username || "",
      password: rowData.password || "",
      exchange_type: rowData.exchange_type || "",
      clearing_account: rowData.clearing_account?.id || "",
      clearer: rowData.clearer?.id || "",
      book: rowData.book?.id || "",
      strategy: rowData.strategy?.id || "",
    });

    // Show success message and apply background color effect
    toast.success(
      "API Settings Row data copied and form populated successfully"
    );
    setInputBackgroundColour("#83bf6e26");
    setTimeout(() => {
      setInputBackgroundColour("");
    }, 2400);

    // Scroll to the top of the form
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  interface ContextMenuPosition {
    mouseX: number;
    mouseY: number;
  }

  const [contextMenu, setContextMenu] = useState<ContextMenuPosition | null>(
    null
  );

  // Function to handle right-click and open the menu
  const handleContextMenu = (event: MouseEvent<HTMLDivElement>) => {
    event.preventDefault();
    setContextMenu(
      contextMenu === null
        ? { mouseX: event.clientX + 2, mouseY: event.clientY - 6 }
        : null
    );
  };

  // Function to handle menu close
  const handleClose = () => {
    setContextMenu(null);
  };

  // Function to handle Paste action
  const handlePaste = async () => {
    try {
      const text = await navigator.clipboard.readText();
      let jsonData;

      try {
        jsonData = JSON.parse(text);
        setBrokerName(jsonData.name);
        window.scrollTo({ top: 0, behavior: "smooth" });
        toast.success("copied and pasted successfully");
        setInputBackgroundColour("#83bf6e26");
        setTimeout(() => {
          setInputBackgroundColour(""); // Then set it again
        }, 2400);
      } catch (error) {
        console.error("Invalid JSON. Pasted as a string:", text);
        jsonData = { rawText: text }; // Fallback if not valid JSON
      }

      // Here, you can use jsonData further as needed
    } catch (err) {
      console.error("Failed to read clipboard contents:", err);
    }

    handleClose();
  };

  // Function to handle Mark action
  const handleResizing = () => {
    setShowRowResizing(!showRowResizing);
    handleClose();
  };

  const handleExportRows = (rows: MRT_Row<any>[]) => {
    const rowData = rows.map((row) => row.original);
    console.log(rowData);
  };

  // const handleDataDownload = async () => {
  //   try {
  //     const response = await axiosInstance.get(
  //       "/paper-app/api-settings/csv/download",
  //       {
  //         responseType: "blob", // Ensure Axios handles binary data properly
  //       }
  //     );

  //     // Create a blob from the response data
  //     const blob = new Blob([response.data], { type: "text/csv" });
  //     const url = window.URL.createObjectURL(blob);

  //     // Create a temporary anchor element to trigger the download
  //     const a = document.createElement("a");
  //     a.href = url;
  //     a.download = "persons.csv"; // Set the file name
  //     document.body.appendChild(a);
  //     a.click();
  //     document.body.removeChild(a);

  //     // Cleanup the URL object
  //     window.URL.revokeObjectURL(url);
  //   } catch (error) {
  //     console.error("Error downloading CSV:", error);
  //   }
  // };

  const handleDataDownload = (table: any) => {
    // Use the table's own rendered row order instead of the raw fetched array,
    // so the CSV always matches what's on screen (sorting/grouping included)
    const rows = table.getRowModel().rows.map((r: any) => r.original);

    if (rows.length === 0) {
      toast.warn("No data available to export.");
      return;
    }

    const columns: { header: string; accessor: (row: any) => any }[] = [
      { header: "Company Name", accessor: (r) => r.company_name },
      { header: "API Company Name", accessor: (r) => r.api_company_name },
      { header: "Company Username", accessor: (r) => r.company_username },
      { header: "Password", accessor: (r) => r.password },
      { header: "Exchange Type", accessor: (r) => r.exchange_type },
      { header: "Clearing Account", accessor: (r) => r.clearing_account?.name || "" },
      { header: "Clearer", accessor: (r) => r.clearer?.name || "" },
      { header: "Book", accessor: (r) => r.book?.name || "" },
      { header: "Strategy", accessor: (r) => r.strategy?.name || "" },
    ];

    const escapeCsvValue = (value: any): string => {
      const str = value == null ? "" : String(value);
      return str.includes(",") || str.includes('"') || str.includes("\n")
        ? `"${str.replace(/"/g, '""')}"`
        : str;
    };

    const csvContent = [
      columns.map((c) => escapeCsvValue(c.header)).join(","),
      ...rows.map((row: any) => columns.map((c) => escapeCsvValue(c.accessor(row))).join(",")),
    ].join("\n");

    const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = "api-settings.csv";
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    window.URL.revokeObjectURL(url);
  };
  // Function to handle Save action
  const handleSaveRow = async ({ row, values, table }: any) => {
    const newValidationErrors: Record<string, string> = {};
    const formValues = row._valuesCache || {};

    if (!values.company_name)
      newValidationErrors.company_name = "Company Name is required";
    if (!values.company_username)
      newValidationErrors.company_username = "Company Username is required";
    if (!values.password) newValidationErrors.password = "Password is required";
    if (!values.exchange_type)
      newValidationErrors.exchange_type = "Exchange Type is required";
    if (!values.clearing_account && !values.clearing_account_id)
      newValidationErrors.clearing_account = "Clearing Account is required";
    if (!values.clearer && !values.clearer_id)
      newValidationErrors.clearer = "Clearer is required";
    if (!values.book && !values.book_id)
      newValidationErrors.book = "Book is required";
    if (!values.strategy && !values.strategy_id)
      newValidationErrors.strategy = "Strategy is required";

    if (Object.keys(newValidationErrors).length) {
      setValidationErrors(newValidationErrors);
      return;
    }

    try {
      const rowId = row.original.id;


      const apiPayload = {
        company_name: values.company_name || row.original.company_name,
        api_company_name: values.api_company_name || row.original.api_company_name,
        company_username: values.company_username || row.original.company_username,
        password: values.password || row.original.password,
        exchange_type: values.exchange_type || row.original.exchange_type,

        clearing_account_id: formValues.clearing_account_id || row.original.clearing_account?.id || "",
        clearer_id: formValues.clearer_id || row.original.clearer?.id || "",
        book_id: formValues.book_id || row.original.book?.id || "",
        strategy_id: formValues.strategy_id || row.original.strategy?.id || "",
      };

      console.log("API Payload to send:", apiPayload);
      console.log("UUID IDs (from original row):");
      console.log({
        clearing_account_id: row.original.clearing_account?.id,
        clearer_id: row.original.clearer?.id,
        book_id: row.original.book?.id,
        strategy_id: row.original.strategy?.id,
      });

      await axiosInstance.put(
        `${backendbaseUrl}/paper-app/api-settings/${rowId}/`,
        apiPayload
      );

      table.setEditingRow(null);
      toast.success("API Settings updated successfully!");
      queryClient.invalidateQueries({ queryKey: ["users"] });
    } catch (error: any) {
      console.error("Error updating API Settings:", error);
      console.error("API error details:", error.response?.data);
      toast.error("Failed to update API Settings. Please try again.");
    }
  };

  const handleBulkDelete = async (rows: MRT_Row<any>[]) => {
    // 1. Get selected row IDs
    const rowIds = rows.map((row) => row.original.id);

    if (rowIds.length === 0) {
      toast.warn("Please select at least one API Settings to delete.");
      return;
    }

    // 2. Debug: Verify selected IDs before sending
    console.log("Selected IDs for deletion:", rowIds);

    try {
      showDeleteConfirmModal({
        title: `Delete ${rowIds.length} selected API Setting(s)?`,
        content: `This will permanently delete ${rowIds.length} API Setting(s). Continue?`,
        onOk: async () => {
          const loadingToast = toast.loading(
            `Deleting ${rowIds.length} API Setting(s)...`
          );
          try {
            // 4. Prepare exact payload format API expects
            const payload = {
              ids: rowIds.filter((id) => id), // Ensure no empty/null IDs
            };

            // 5. Debug: Verify final payload
            console.log("Sending delete payload:", payload);

            // 6. Make API call
            const response = await axiosInstance.delete(
              `${backendbaseUrl}/paper-app/apisettings/export-delete/`,
              {
                data: payload,
                headers: {
                  "Content-Type": "application/json",
                  "X-Requested-With": "XMLHttpRequest",
                },
              }
            );

            // 7. Handle response
            if (response.status === 200) {
              toast.success(
                `Successfully deleted ${rowIds.length} API Setting(s)`
              );

              // 8. Refresh data and clear selection
              queryClient.invalidateQueries({ queryKey: ["users"] });
              table.setRowSelection({});
            } else {
              throw new Error(response.data?.message || "Unknown error occurred");
            }
          } catch (error: any) {
            // 9. Enhanced error handling
            console.error("Delete error details:", {
              message: error.message,
              response: error.response?.data,
              status: error.response?.status,
            });

            const errorMessage =
              error.response?.data?.detail ||
              error.response?.data?.message ||
              error.message ||
              "Failed to delete brokers";

            toast.error(`Deletion failed: ${errorMessage}`);
          } finally {
            toast.dismiss(loadingToast);
          }
        },
      });
    } catch (error) {
      console.error("Confirmation dialog error:", error);
      toast.error("An error occurred during the deletion process.");
    }
  };
  const table = useMaterialReactTable({
    columns,

    enableStickyHeader: true,
    enableStickyFooter: true,
    enableClickToCopy: true,
    enableKeyboardShortcuts: true,
    // enableRowNumbers: true,
    enableColumnActions: true,
    enableColumnDragging: true,
    enableGlobalFilter: false,
    enableGrouping: true,
    enableHiding: true,
    enableSorting: true,
    enableColumnPinning: true,
    onPaginationChange: setPagination,
    onColumnFiltersChange: setColumnFilters,
    onColumnVisibilityChange: setColumnVisibility,
    onDensityChange: setDensity,
    onGlobalFilterChange: setGlobalFilter,
    onShowColumnFiltersChange: setShowColumnFilters,
    onShowGlobalFilterChange: setShowGlobalFilter,
    onSortingChange: setSorting,
    manualSorting: true,
    manualPagination: true,
    enableRowSelection: true,
    // positionToolbarAlertBanner: "bottom",
    // layoutMode: "semantic",
    // enableColumnResizing: showRowResizing,
    enableColumnResizing: true, // Already set
    // columnResizeMode: "onEnd", // Ensures precise resizing
    // defaultColumn: {
    //   minSize: 50, // Smallest practical width
    //   enableResizing: true,
    // },
    enableFilterMatchHighlighting: true,
    rowCount: totalCount,
    manualFiltering: false,
    data: data?.results || [],
    enableDensityToggle: false,
    createDisplayMode: "row", // ('modal', and 'custom' are also available)
    editDisplayMode: "row", // ('modal', 'cell', 'table', and 'custom' are also available)
    enableEditing: true,

    // Top toolbar customization
    muiTopToolbarProps: ({ table }) => ({
      sx: {
        backgroundColor: "#fff",
        padding: "8px",
        // Optional: Style the inner MuiBox-root (css-wsew38) for visual confirmation
        "& .MuiBox-root.css-wsew38": {
          backgroundColor: "#fff",
          display: "flex",
          alignItems: "center",
          gap: "8px",
        },
      },
      className: "top-toolbar-wrapper__new",
    }),

    muiTableContainerProps: ({ table }) => ({
      sx: {
        backgroundColor: "#fff",
      },
      className: "table-container-wrapper__new",
    }),
    muiTableFooterProps: ({ table }) => ({
      sx: {
        backgroundColor: "#fff",
      },
      className: "table-footer-wrapper__new",
    }),
    muiBottomToolbarProps: ({ table }) => ({
      sx: {
        backgroundColor: "#fff",
        padding: "8px",
      },
      className: "bottom-toolbar-wrapper__new",
    }),

    muiTableBodyRowProps: ({ row, table }: any) => ({
      onKeyDown: (event: React.KeyboardEvent<HTMLTableRowElement>) => {
        if (event.key === "Enter" && table.getState().editingRow) {
          event.preventDefault();
          const editingRow = table.getState().editingRow;
          if (editingRow) {
            // Get the current values from the editing row
            const values = editingRow._valuesCache;

            // Create the payload the API expects
            const apiPayload = {
              id: editingRow.original.id,
              company_name: values.company_name,
              api_company_name: values.api_company_name,
              company_username: values.company_username,
              password: values.password,
              exchange_type: values.exchange_type,
              clearing_account_id:
                values.clearing_account ||
                editingRow.original.clearing_account?.id,
              clearer_id: values.clearer || editingRow.original.clearer?.id,
              book_id: values.book || editingRow.original.book?.id,
              strategy_id: values.strategy || editingRow.original.strategy?.id,
            };

            // Call the save handler with properly formatted data
            handleSaveRow({
              row: editingRow,
              values: apiPayload,
              table,
            });
          }
        }
      },
    }),

    enableColumnOrdering: true, // ✅ Enables column drag-and-drop
    enableRowOrdering: false, // ✅ Enables row drag-and-drop
    getRowId: (row) => row.id,
    enableColumnFilterModes: true, //enable changing filter mode for all columns unless explicitly disabled in a column def
    // initialState: { showColumnFilters: true }, //show filters by default
    filterFns: {
      customFilterFn: (row, id, filterValue) => {
        return row.getValue(id) === filterValue;
      },
    },

    // defaultDisplayColumn: {
    //   enableResizing: true, //turn on some features that are usually off for all display columns
    // },
    displayColumnDefOptions: {
      "mrt-row-actions": {
        enableColumnActions: true,
        size: 120, //set custom width
        muiTableHeadCellProps: {
          // align: "center", //change head cell props
        },
      },
      "mrt-row-numbers": {
        enableColumnDragging: true,
        enableColumnOrdering: true, //turn on some features that are usually off
        enableResizing: true,
        muiTableHeadCellProps: {
          sx: {
            fontSize: "1.2rem",
          },
        },
      },
      "mrt-row-select": {
        enableColumnActions: true,
        enableHiding: true,
        // size: 50,
      },
    },
    renderToolbarInternalActions: (props) => <CommonToolbarInternalActions {...props} />,
    renderTopToolbarCustomActions: ({ table }) => (
      <Box
        className="table-download__wrapper"
        sx={{
          display: "flex",
          gap: "6px",
          padding: "0px",
          flexWrap: "wrap",
        }}
      >
        <Button startIcon={<UploadFileIcon />} onClick={handleFileUploadOpen}>
          Upload File
        </Button>
        <Button
          //export all data that is currently in the table (ignore pagination, sorting, filtering, etc.)
          onClick={() => handleDataDownload(table)}
          startIcon={<BrowserUpdatedIcon />}
        >
          Export All Data
        </Button>
        {/* <Button
          disabled={table.getPrePaginationRowModel().rows.length === 0}
          //export all rows, including from the next page, (still respects filtering and sorting)

          startIcon={<FileDownloadIcon />}
        >
          Export All Rows
        </Button>
        <Button
          disabled={table.getRowModel().rows.length === 0}
          //export all rows as seen on the screen (respects pagination, sorting, filtering, etc.)

          startIcon={<FileDownloadIcon />}
        >
          Export Page Rows
        </Button> */}
        <Button
          disabled={
            !table.getIsSomeRowsSelected() && !table.getIsAllRowsSelected()
          }
          //only export selected rows
          onClick={() => handleExportRows(table.getSelectedRowModel().rows)}
          startIcon={<FileDownloadIcon />}
        >
          Export Selected Rows
        </Button>
        {(table.getIsSomeRowsSelected() || table.getIsAllRowsSelected()) && (
          <Button
            style={{ color: "red" }}
            onClick={() => handleBulkDelete(table.getSelectedRowModel().rows)}
            startIcon={<DeleteIcon />}
          >
            Delete Selected ({table.getSelectedRowModel().rows.length})
          </Button>
        )}
      </Box>
    ),

    // muiTableProps: {
    //   sx: {
    //     border: '1px solid rgba(81, 81, 81, .5)',
    //     caption: {
    //       captionSide: 'top',
    //     },
    //   },
    // },
    muiTableHeadCellProps: {
      sx: {
        border: "1px solid #e0e0e087",
        fontStyle: "normal",
        fontWeight: "normal",
      },
    },

    muiTablePaperProps: {
      elevation: 0,
      sx: {
        borderRadius: "0",
        border: "0",
      },
    },
    localization: {
      filterCustomFilterFn: "Custom Filter Fn",
    } as any,

    muiToolbarAlertBannerProps: isLoadingUsersError
      ? {
        color: "error",
        children: "Error loading data",
      }
      : undefined,

    onCreatingRowCancel: () => setValidationErrors({}),
    onCreatingRowSave: handleCreateUser,
    onEditingRowCancel: () => setValidationErrors({}),
    // onEditingRowSave: handleeditsave,
    onEditingRowSave: handleSaveRow,

    renderRowActions: ({ row, table }) => (
      <Box sx={{ display: "flex", gap: "1rem" }}>
        <Tooltip title="Edit" className="editIcon">
          <IconButton onClick={() => table.setEditingRow(row)}>
            <EditIcon />
          </IconButton>
        </Tooltip>
        <Tooltip title="Delete" className="deleteIcon">
          <IconButton color="error" onClick={() => openDeleteConfirmModal(row)}>
            <DeleteIcon />
          </IconButton>
        </Tooltip>
        <Tooltip title="Copy Row">
          <IconButton onClick={() => handleCopyRow(row)}>
            {" "}
            {/* ✅ Pass row as argument */}
            <ContentCopyIcon />
          </IconButton>
        </Tooltip>
      </Box>
    ),

    state: {
      columnVisibility,
      sorting,
      columnFilters,
      pagination,
      isLoading: isLoadingUsers,
      isSaving: isCreatingUser || isUpdatingUser || isDeletingUser,
      showAlertBanner: isLoadingUsersError,
      showProgressBars: isFetchingUsers,
      showColumnFilters: true,
    },
  });

  const transformedFilters = columnFilters.map((filter) => ({
    ...filter,
    mode: table.getColumn(filter.id)?.getFilterFn()?.name || "contains",
  }));

  useEffect(() => {
    const transformedFilters = columnFilters.map((filter) => ({
      ...filter,
      mode: table.getColumn(filter.id)?.getFilterFn()?.name || "contains",
    }));

    setFilterModes(transformedFilters);
  }, [columnFilters, table]);

  const someEventHandler = (event: any) => {
    console.info("rows :", table.getRowModel().rows); //example - get access to all page rows in the table
    console.info("row model :", table.getSelectedRowModel()); //example - get access to all selected rows in the table
    console.info("row model :", table.getState().sorting); //example - get access to the current sorting state without having to manage it yourself
  };
  return (
    <div className="page-body">
      <Container fluid>
        <Row>
          <div>
            <div className="table-ad">
              <Accordion defaultActiveKey="0" className="table-ad__addInputs">
                <Accordion.Item eventKey="0">
                  <Accordion.Header className="accordion_button">
                    API Settings
                  </Accordion.Header>
                  <Accordion.Body>
                    <div className="form_contain">
                      <div
                        className={`flex formWrapper ${inputBackgroundColour !== "" ? "inputboxcustom" : ""
                          }`}
                        style={{ backgroundColor: inputBackgroundColour }}
                      >
                        <Box
                          sx={{
                            width: "100%",

                            p: { xs: 1, sm: 1 },
                            pt: "20px !important",
                            backgroundColor: "#ffff",
                            // backgroundColor: "#f8f9fa",

                            borderRadius: "4px",
                            border: "1px solid #e0e0e0",
                          }}
                        >
                          <Box
                            className="form_default"
                            //   component="form"
                            //   onSubmit={handleSubmit}
                            sx={{
                              display: "flex",
                              flexWrap: "wrap",
                              alignItems: "flex-start",
                              justifyContent: "start",
                              gap: 0.5,
                              "& > *": {
                                // flex: "1 1 0px",
                                minWidth: {
                                  xs: "100%",
                                  sm: "48%",
                                  md: "23%",
                                  lg: "15%",
                                  xl: "7.5%",
                                },
                              },
                            }}
                          >
                            <CompactTextField
                              label="Company Name"
                              value={formData.company_name}
                              onChange={(value) =>
                                updateFormData("company_name", value)
                              }
                              name="company_name"
                              error={Boolean(
                                formErrors.company_name && touched.company_name
                              )}
                              validateOnBlur={(value) =>
                                validateField("company_name", value)
                              }
                              slotProps={{
                                inputLabel: {
                                  shrink: true,
                                },
                              }}
                              onFocus={() => handleFocus("company_name")}
                              disabled // ✅ makes the field non-editable
                            />

                            <CompactTextField
                              label="API Company Name"
                              value={formData.api_company_name}
                              onChange={(value) =>
                                updateFormData("api_company_name", value)
                              }
                              name="api_company_name"
                              error={Boolean(
                                formErrors.api_company_name &&
                                touched.api_company_name
                              )}
                              // helperText={
                              //   touched.company_name
                              //     ? formErrors.company_name
                              //     : ""
                              // }
                              validateOnBlur={(value) =>
                                validateField("api_company_name", value)
                              }
                              slotProps={{
                                inputLabel: {
                                  shrink: true,
                                },
                              }}
                              onFocus={() => handleFocus("api_company_name")} // Add onFocus
                            />
                            <CompactTextField
                              label="API Company Username"
                              value={formData.company_username}
                              onChange={(value) =>
                                updateFormData("company_username", value)
                              }
                              name="company_username"
                              error={Boolean(
                                formErrors.company_username &&
                                touched.company_username
                              )}
                              // helperText={
                              //   touched.company_username
                              //     ? formErrors.company_username
                              //     : ""
                              // }
                              validateOnBlur={(value) =>
                                validateField("company_username", value)
                              }
                              slotProps={{
                                inputLabel: {
                                  shrink: true,
                                },
                              }}
                              onFocus={() => handleFocus("company_username")} // Add onFocus
                            />
                            {/* <CompactTextField
                              label="Password"
                              value={formData.password}
                              onChange={(value) =>
                                updateFormData("password", value)
                              }
                              type="password"
                              name="password"
                              error={Boolean(
                                formErrors.password && touched.password
                              )}
                              // helperText={
                              //   touched.password ? formErrors.password : ""
                              // }
                              validateOnBlur={(value) =>
                                validateField("password", value)
                              }
                              slotProps={{
                                inputLabel: {
                                  shrink: true,
                                },
                              }}
                              onFocus={() => handleFocus("password")} // Add onFocus
                            /> */}

                            <CompactTextField
                              label="API Password"
                              value={formData.password}
                              onChange={(value) =>
                                updateFormData("password", value)
                              }
                              type={showPassword ? "text" : "password"} // Toggle between text and password
                              name="password"
                              error={Boolean(
                                formErrors.password && touched.password
                              )}
                              validateOnBlur={(value) =>
                                validateField("password", value)
                              }
                              slotProps={{
                                inputLabel: {
                                  shrink: true,
                                },
                                htmlInput: {
                                  endAdornment: (
                                    <InputAdornment
                                      position="end"
                                      className="showHide_password"
                                    >
                                      <IconButton
                                        onClick={handleTogglePassword}
                                        onMouseDown={(e) => e.preventDefault()} // Prevent focus loss
                                        edge="end"
                                        aria-label={
                                          showPassword
                                            ? "Hide password"
                                            : "Show password"
                                        }
                                      >
                                        {showPassword ? (
                                          <VisibilityOffIcon />
                                        ) : (
                                          <VisibilityIcon />
                                        )}
                                      </IconButton>
                                    </InputAdornment>
                                  ),
                                },
                              }}
                              onFocus={() => handleFocus("password")}
                            />
                            <CompactSelect
                              label="Exchange Type"
                              value={formData.exchange_type}
                              onChange={(value) =>
                                updateFormData("exchange_type", value)
                              }
                              options={exchangeTypes.map((type) => ({
                                value: type.id,
                                label: type.name,
                              }))}
                              name="exchange_type"
                              error={Boolean(
                                formErrors.exchange_type &&
                                touched.exchange_type
                              )}
                              // helperText={
                              //   touched.exchange_type
                              //     ? formErrors.exchange_type
                              //     : ""
                              // }
                              validateOnBlur={(value) =>
                                validateField("exchange_type", value)
                              }
                              slotProps={{
                                inputLabel: {
                                  shrink: true,
                                },
                              }}
                              onFocus={() => handleFocus("exchange_type")} // Add onFocus
                            />
                            <CompactSelect
                              label="Clearing Account"
                              value={formData.clearing_account}
                              onChange={(value) =>
                                updateFormData("clearing_account", value)
                              }
                              options={clearingAccounts.map((account) => ({
                                value: account.id,
                                label: account.name,
                              }))}
                              name="clearing_account"
                              error={Boolean(
                                formErrors.clearing_account &&
                                touched.clearing_account
                              )}
                              // helperText={
                              //   touched.clearing_account
                              //     ? formErrors.clearing_account
                              //     : ""
                              // }
                              validateOnBlur={(value) =>
                                validateField("clearing_account", value)
                              }
                              slotProps={{
                                inputLabel: {
                                  shrink: true,
                                },
                              }}
                              onFocus={() => handleFocus("clearing_account")} // Add onFocus
                            />
                            <CompactSelect
                              label="Clearer"
                              value={formData.clearer}
                              onChange={(value) =>
                                updateFormData("clearer", value)
                              }
                              options={clearers.map((clearer) => ({
                                value: clearer.id,
                                label: clearer.name,
                              }))}
                              name="clearer"
                              error={Boolean(
                                formErrors.clearer && touched.clearer
                              )}
                              // helperText={
                              //   touched.clearer ? formErrors.clearer : ""
                              // }
                              validateOnBlur={(value) =>
                                validateField("clearer", value)
                              }
                              slotProps={{
                                inputLabel: {
                                  shrink: true,
                                },
                              }}
                              onFocus={() => handleFocus("clearer")} // Add onFocus
                            />
                            <CompactSelect
                              label="Book"
                              value={formData.book}
                              onChange={(value) =>
                                updateFormData("book", value)
                              }
                              options={books.map((book) => ({
                                value: book.id,
                                label: book.name,
                              }))}
                              name="book"
                              error={Boolean(formErrors.book && touched.book)}
                              // helperText={touched.book ? formErrors.book : ""}
                              validateOnBlur={(value) =>
                                validateField("book", value)
                              }
                              slotProps={{
                                inputLabel: {
                                  shrink: true,
                                },
                              }}
                              onFocus={() => handleFocus("book")} // Add onFocus
                            />
                            <CompactSelect
                              label="Strategy"
                              value={formData.strategy}
                              onChange={(value) =>
                                updateFormData("strategy", value)
                              }
                              options={strategies.map((strategy) => ({
                                value: strategy.id,
                                label: strategy.name,
                              }))}
                              name="strategy"
                              error={Boolean(
                                formErrors.strategy && touched.strategy
                              )}
                              // helperText={
                              //   touched.strategy ? formErrors.strategy : ""
                              // }
                              validateOnBlur={(value) =>
                                validateField("strategy", value)
                              }
                              slotProps={{
                                inputLabel: {
                                  shrink: true,
                                },
                              }}
                              sx={{
                                maxWidth: 220,
                                width: "100%",
                              }}
                              onFocus={() => handleFocus("strategy")} // Add onFocus
                            />

                            <Button
                              onClick={formCreate}
                              variant="contained"
                              fullWidth
                              sx={{
                                height: { xs: "36px", sm: "32px" },
                                flex: { xs: "1 1 auto", sm: "0 0 auto" },
                                minWidth: { xs: "100%", sm: "100px" },
                                maxWidth: { sm: "150px" },
                                backgroundColor: "#00bcd4",
                                textTransform: "none",
                                fontSize: "0.75rem",
                                "&:hover": {
                                  backgroundColor: "#008c9e",
                                },
                              }}
                            >
                              Add
                            </Button>
                          </Box>
                        </Box>
                      </div>
                    </div>
                  </Accordion.Body>
                </Accordion.Item>
              </Accordion>
              <div
                className="table-ad__wrapper"
                onContextMenu={handleContextMenu}
              >
                <div className="table-ad__wrapperCard">
                  <MaterialReactTable table={table} />

                  {/* Context Menu */}
                  <Menu
                    open={contextMenu !== null}
                    onClose={handleClose}
                    anchorReference="anchorPosition"
                    anchorPosition={
                      contextMenu !== null
                        ? { top: contextMenu.mouseY, left: contextMenu.mouseX }
                        : undefined
                    }
                  >
                    {/* <MenuItem onClick={handlePaste}>Paste</MenuItem> */}
                    <MenuItem onClick={handleResizing}>
                      {showRowResizing ? "Disable Resizing" : "enable Resizing"}
                    </MenuItem>
                  </Menu>
                </div>
              </div>
            </div>
          </div>
        </Row>
      </Container>
    </div>
  );
};

//CREATE hook (post new user to api)
function useCreateUser() {
  const queryClient = useQueryClient();
  console.log("create user");
  return useMutation({
    mutationFn: async (user: User) => {
      //send api update request here
      await new Promise((resolve) => setTimeout(resolve, 1000)); //fake api call
      return Promise.resolve();
    },
    //client side optimistic update
    onMutate: (newUserInfo: User) => {
      queryClient.setQueryData(
        ["users"],
        (prevUsers: any) =>
          [
            ...prevUsers,
            {
              ...newUserInfo,
              id: (Math.random() + 1).toString(36).substring(7),
            },
          ] as User[]
      );
    },
    // onSettled: () => queryClient.invalidateQueries({ queryKey: ['users'] }), //refetch users after mutation, disabled for demo
  });
}

//READ hook (get users from api)
function useGetData(
  // filterModes: { mode: string; id: string; value: unknown }[],
  pagination: { pageIndex: number; pageSize: number },
  setTotalCount: any,
  sorting: any
) {
  return useQuery<{ results: User[]; totalCount: number }>({
    // ✅ Correct return type
    queryKey: ["users", pagination, sorting], // Ensure proper re-fetching
    queryFn: async () => {
      let url = `${backendbaseUrl}/paper-app/api-settings/?page=${pagination.pageIndex + 1
        }&page_size=${pagination.pageSize}`;

      // if (filterModes.length > 0) {
      //   console.log("filterModes---,", filterModes);
      //   const queryParams = filterModes
      //     .map((e) => `fieldName_${e.id}=${String(e.value)}_${e.mode}`)
      //     .join("&");

      //   url += `&${queryParams}`;
      // }
      // console.log("sortparams:", sorting);
      if (sorting.length > 0) {
        const sortParams = `sortField_${sorting[0].id}=${sorting[0].desc}_sorting`;
        url += `&${sortParams}`;

        console.log("yesss");
      } else {
        console.log("sortParams");
      }

      const response = await axiosInstance.get(url);
      console.log("response:", response.data.results);
      setTotalCount(response.data.count);
      return {
        results: response.data.results as User[],
        totalCount: response.data.count as number,
      };
    },
    refetchOnWindowFocus: false,
  });
}

// Update useUpdateUser to use snake_case
function useUpdateUser() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (user: User) => {
      if (!user || !user.id) {
        throw new Error("User object is invalid or missing ID");
      }

      const apiPayload = {
        company_name: user.company_name,
        api_company_name: user.api_company_name,
        company_username: user.company_username,
        password: user.password,
        exchange_type: user.exchange_type,
        clearing_account_id: user.clearing_account?.id,
        clearer_id: user.clearer?.id,
        book_id: user.book?.id,
        strategy_id: user.strategy?.id,
      };

      try {
        const { data } = await axiosInstance.put(
          `${backendbaseUrl}/paper-app/api-settings/${user.id}/`,
          apiPayload
        );
        return data;
      } catch (error) {
        console.error("API Request Failed:", error);
        throw error;
      }
    },
    onMutate: async (newUserInfo: User) => {
      await queryClient.cancelQueries({ queryKey: ["users"] });
      const previousUsers = queryClient.getQueryData(["users"]);

      queryClient.setQueryData(["users"], (oldData: any) =>
        oldData?.map((prevUser: User) =>
          prevUser.id === newUserInfo.id ? newUserInfo : prevUser
        )
      );

      return { previousUsers };
    },
    onError: (err, newUser, context) => {
      console.error("Update Failed:", err);
      queryClient.setQueryData(["users"], context?.previousUsers);
    },
    onSettled: () => {
      queryClient.invalidateQueries({ queryKey: ["users"] });
    },
  });
}

//DELETE hook (delete user in api)
function useDeleteUser() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async (userId: string) => {
      //send api update request here
      // await new Promise((resolve) => setTimeout(resolve, 1000)); //fake api call
      try {
        await axiosInstance.delete(
          `${backendbaseUrl}/paper-app/api-settings/${userId}/`
        );
        console.log("userId", userId);
      } catch (error) {
        console.error("Error deleting user:", error);
        throw error;
      }

      return Promise.resolve();
    },
    //client side optimistic update
    onMutate: async (userId: string) => {
      await queryClient.cancelQueries({ queryKey: ["users"] });

      const previousUsers = queryClient.getQueryData(["users"]);

      queryClient.setQueryData(["users"], (prevUsers: any) =>
        prevUsers?.filter((user: User) => user.id !== userId)
      );

      return { previousUsers };
    },
    onError: (err, userId, context) => {
      console.error("❌ Delete Failed:", err);
    },
    onSettled: () => queryClient.invalidateQueries({ queryKey: ["users"] }), //refetch users after mutation, disabled for demo
  });
}

//react query setup in App.tsx
const ReactQueryDevtoolsProduction = lazy(() =>
  import("@tanstack/react-query-devtools/build/modern/production.js").then(
    (d) => ({
      default: d.ReactQueryDevtools,
    })
  )
);

const queryClient = new QueryClient();

export default function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <Example />
      {/* <Suspense fallback={null}>
        <ReactQueryDevtoolsProduction />
      </Suspense> */}
    </QueryClientProvider>
  );
}

const validateRequired = (value: string) => !!value.length;
const validateEmail = (email: string) =>
  !!email.length &&
  email
    .toLowerCase()
    .match(
      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
    );

function validateUser(user: User) {
  return {
    // brokerName: !validateRequired(user.name)
    //   ? "First Name is Required"
    //   : "",
    // name: !validateRequired(user.name) ? "Last Name is Required" : "",
    // email: !validateEmail(user.email) ? "Incorrect Email Format" : "",
  };
}
